export default __webpack_public_path__ + "static/media/Harlekin.179e6853.MP4";